// core
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// campfire
import { MatDialog } from '@campfire-nx/material';

// services

// components


@Component({
  selector: 'landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  quote!: any;
  reference!: any;
  isAhmCar!: any;
  productSlug!: any;
  productClass!: string;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.data.reference) {
      this.reference = this.route.snapshot.data.reference;
      this.quote = this.reference.quote;
      this.quote.uuid = this.reference.uuid;
      this.productSlug = this.quote.data.product_slug;
      
      if (this.productSlug.search('ahm-car') > -1) {
        this.productClass = 'ahm-car'
      } else {
        this.productClass = this.reference.product.class;
      }
    }
  }
}
